import { V as VisibilityMode } from '../../../../../index-B0HfjrH_.js';

"use strict";
const pluginVersion = "12.2.1";
const defaultOptions = {
  alignValue: "left",
  mergeValues: true,
  perPage: 20,
  rowHeight: 0.9,
  showValue: VisibilityMode.Auto
};
const defaultFieldConfig = {
  fillOpacity: 70,
  lineWidth: 0
};

export { defaultFieldConfig, defaultOptions, pluginVersion };
